import authConfig from "./authConfig";

export const profileDropdownList = [
    {
        url: authConfig['url-logout'],
        label: "Logout"
    }
]


export const segnalazioniProva = [
    {
        url: "/",
        label: "Segnalazione 1"
    },
    {
        url: "/",
        label: "Segnalazione 2"
    },
    {
        url: "/",
        label: "Segnalazione 3"
    },
    {
        url: "/",
        label: "Segnalazione 4"
    }
]





